/**
 * lead-gen.js
 * Handles the video lightbox for lead gen landing pages.
 */

(function () {
  'use strict';

  var lightbox = null;
  var lightboxRatio = null;

  function createLightbox() {
    var el = document.createElement('div');
    el.id = 'lg-lightbox';
    el.className = 'lg-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Video player');
    el.innerHTML = [
      '<div class="lg-lightbox__inner">',
      '  <button class="lg-lightbox__close" aria-label="Close video">&times;</button>',
      '  <div class="lg-lightbox__ratio"></div>',
      '</div>'
    ].join('');

    document.body.appendChild(el);

    lightboxRatio = el.querySelector('.lg-lightbox__ratio');

    // Close button
    el.querySelector('.lg-lightbox__close').addEventListener('click', closeLightbox);

    // Backdrop click
    el.addEventListener('click', function (e) {
      if (e.target === el) closeLightbox();
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-open')) {
        closeLightbox();
      }
    });

    return el;
  }

  function getLightbox() {
    if (!lightbox) {
      lightbox = createLightbox();
    }
    return lightbox;
  }

  function loadIframe(videoId) {
    lightboxRatio.innerHTML = '<iframe src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&enablejsapi=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
  }

  function openLightbox(videoId) {
    var lb = getLightbox();

    loadIframe(videoId);

    lb.classList.add('is-open');
    document.body.classList.add('modal-open');
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.body.classList.remove('modal-open');
    // Destroy iframe to stop audio/video
    lightboxRatio.innerHTML = '';
  }

  function bindVideoCards() {
    var cards = document.querySelectorAll('.lg-card--video[data-video-id]');
    cards.forEach(function (card) {
      if (card.dataset.lgBound) return;
      card.dataset.lgBound = 'true';
      card.addEventListener('click', function (e) {
        e.preventDefault();
        openLightbox(card.dataset.videoId);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openLightbox(card.dataset.videoId);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bindVideoCards);
})();
